module.exports = __webpack_public_path__ + "static/media/galerija_2017 (41).a2ab1e79.jpg";